<template>
    <div class="overview">
        <student-overview v-if="isStudent" />

        <customer-overview v-else-if="isCustomer" />

        <employee-overview v-else />
    </div>
</template>

<script>
    import CustomerOverview from '@/taskflex/customers/pages/Overview';
    import EmployeeOverview from '@/taskflex/employees/pages/Overview';
    import StudentOverview from '@/taskflex/students/pages/Overview';
    import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters('auth', [
                'isCustomer',
                'isStudent',
            ]),
        },

        components: {
            CustomerOverview,
            EmployeeOverview,
            StudentOverview,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/users/pages/Overview.vue